import React from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { useSelector, useDispatch } from "react-redux";
import { getRemainingDebateAction } from "../../redux/actions/check_remaining_debate_action";
import Head from "../Header/head";
import { setSession } from "../../utils/session";
// import "../../common/css/common.css";
import "./subscription.css";
import axiosInstance from "../../services/axios";

function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!stripe || !elements) {
  //     // Stripe.js has not yet loaded.
  //     // Make sure to disable form submission until Stripe.js has loaded.
  //     return;
  //   }

  //   setIsProcessing(true);
  //   try{
  //     const { error } = await stripe.confirmPayment({
  //       elements,
  //       confirmParams: {
  //         // Make sure to change this to your payment completion page
  //         return_url: `${window.location.origin}/completion`,
  //         // redirect:'if_required'
  //       },
  //     })
  //     if(error){
  //       console.log(error.message)
  //     }
  //     else{
  //       const temp = {"tempdata":"csdsdfsdfsd"}
  //       console.log(temp)
  //       const response = await axiosInstance.get("http://localhost:8000/api/v1/subscription/check_remaining_debate")
  //       console.log(response,"from success")
  //       // setSession(temp)
  //     }
  //     // if (paymentIntent.status === "succeeded") {
  //     //   // Call your API here
  //     //   // await fetch("http://localhost:8000/api/v1/subscription/check_remaining_debate", {
  //     //   //   method: "POST",
  //     //   //   headers:{
  //     //   //     "Authorization":` Bearer ${localStorage.getItem("accessToken")}`,
  //     //   //     'Content-Type': 'application/json',
  //     //   //   },
  //     //   //   // body: JSON.stringify({ paymentIntentId: paymentIntent.id }),
  //     //   // });
  
  //     //   alert("Payment successful!");
  //     // } else {
  //     //   setMessage("Payment failed.");
  //     // }
  //   // if (error.type === "card_error" || error.type === "validation_error") {
  //   //   setMessage(error.message);
  //   //   console.log("errro hai")
  //   // } else {
  //   //   console.log("success ")
  //   //   // alert()
  //   //   // console.log("An unexpected error")
  //   //   // setMessage("An unexpected error occured.");
  //   //}
  //   }
  //   catch(err){
  //     console.log(err,"from error catchign")
  //   }

  //   setIsProcessing(false);
  // };

  const handleSubmit = async (event) => {
    // Prevent default form submission.
    event.preventDefault();
  
    // Ensure Stripe.js has loaded.
    if (!stripe || !elements) {
      console.error('Stripe.js has not loaded.');
      return;
    }
  
    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/completion`,
        },
      });
  
      // if (result.error) {
      //   // Handle errors (e.g., incomplete payment details).
      //   console.error(result.error.message);
      // } else if (result.paymentIntent.status === 'succeeded') {
      //   // Payment succeeded, perform additional actions here.
      //   console.log('Payment succeeded');
      //   alert('Payment succeeded'); // Replace with your desired action.
      // } else if (result.paymentIntent.status === 'requires_action') {
      //   // Additional action required (e.g., 3D Secure authentication).
      //   console.log('Additional action required');
      //   alert('Additional action required'); // Replace with your desired action.
      // } else {
      //   // Unexpected status, handle accordingly.
      //   console.error(`Unexpected payment status: ${result.paymentIntent.status}`);
      // }
    } catch (error) {
      // Handle other errors.
      console.error(`Error confirming payment: ${error.message}`);
    }
  };
  
  return (
    <>
    <Head/>
    <div className="container payment-page">
      <div className="row">
        <div className="col-sm-6">
          <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />
            <button className="subscribe-button" disabled={isProcessing || !stripe || !elements} id="submit">
              <span id="button-text">
                {isProcessing ? "Processing ... " : "Pay now"}
              </span>
            </button>
            {/* Show any error or success messages */}
            {message && <div id="payment-message">{message}</div>}
          </form>
        </div>
        {/* <div id="details-box" className="col-sm-6">
        <div class="card w-100">
          <div className="card-body">
            <h5 className="card-title">Subscription plan : Starter</h5>
            <h5 className="card-title">Price: $30</h5>
    
            <li className="card-text">Detail Number 1</li>
            <li className="card-text">Details Number 2</li>
            <li className="card-text">Details Number 3</li>


          </div>
        </div>

           
          </div> */}

      </div>

    </div>
   
    </>
    
  );
}

export default CheckoutForm